import { Scene } from '../Scene';
import { SceneManifest } from '../SceneManifest';

export async function loadFeatures(scene: Scene, manifest: SceneManifest): Promise<void> {
  if (!manifest.features) return;
  const registry = scene.ctx.engine.featureRegistry;

  for (const [name, options] of Object.entries(manifest.features)) {
    if (!registry.has(name)) {
      console.warn(`Unknown scene feature: '${name}'`);
      continue;
    }
    const feature = registry.create(name, options);
    await feature.init(scene);
    scene.features.set(name, feature);
  }
}
